import { useState } from 'react';
import { resolveMediaUrl, getUserInitials } from '../../utils/mediaUrl.js';
import './UserAvatar.css';

export default function UserAvatar({
  user,
  size = 'md',
  className = '',
  showRing = false,
  title,
}) {
  const avatarUrl = resolveMediaUrl(
    user?.profile_picture_url,
    user?.profile_picture_updated_at,
  );
  // Track which URL failed to load, and derive the error state from the current
  // URL — so a new avatarUrl is retried automatically without a reset effect.
  const [failedUrl, setFailedUrl] = useState(null);
  const imageError = !!avatarUrl && failedUrl === avatarUrl;

  const initials = getUserInitials(user);
  const label = title
    || (user?.first_name || user?.last_name
      ? `${user.first_name || ''} ${user.last_name || ''}`.trim()
      : user?.telephone || 'Utilisateur');

  const showImage = avatarUrl && !imageError;

  return (
    <span
      className={`user-avatar user-avatar-${size} ${showRing ? 'user-avatar-ring' : ''} ${className}`.trim()}
      title={label}
      aria-hidden={!title}
    >
      {showImage ? (
        <img
          src={avatarUrl}
          alt=""
          className="user-avatar-img"
          onError={() => setFailedUrl(avatarUrl)}
        />
      ) : (
        <span className="user-avatar-initials" aria-hidden="true">{initials}</span>
      )}
    </span>
  );
}
